import React from 'react';
import { StudentExamModel } from '../../../../models';
import { Calendar, Edit3, Trash2 } from 'lucide-react';

interface StudentExamCardProps {
    exam: StudentExamModel;
    onEdit: (exam: StudentExamModel) => void;
    onDelete: (id: string) => void;
}

const StudentExamCard: React.FC<StudentExamCardProps> = ({ exam, onEdit, onDelete }) => {
    return (
        <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-100 shadow-sm hover:shadow-lg hover:shadow-indigo-100/10 transition-all flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div className="space-y-0.5">
                    <div className="flex items-center gap-2 text-[10px] font-black text-slate-300">
                        <Calendar size={11} />
                        {new Date(exam.date).toLocaleDateString()}
                    </div>
                    <div className="flex items-center gap-2 flex-wrap">
                        <h4 className="text-lg font-black text-slate-800">{exam.title}</h4>
                        {exam.examType && (
                            <span className="px-2 py-0.5 bg-indigo-50 text-indigo-600 rounded-md text-[11px] font-bold">
                                {exam.examType}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => onEdit(exam)}
                        className="w-9 h-9 rounded-lg bg-slate-50 text-slate-400 hover:bg-indigo-50 hover:text-indigo-600 transition-all flex items-center justify-center"
                    >
                        <Edit3 size={16} />
                    </button>
                    <button
                        onClick={() => onDelete(exam.id)}
                        className="w-9 h-9 rounded-lg bg-slate-50 text-slate-400 hover:bg-rose-50 hover:text-rose-500 transition-all flex items-center justify-center"
                    >
                        <Trash2 size={16} />
                    </button>
                </div>
            </div>

            <div className="flex flex-wrap gap-2">
                {Object.entries(exam.scores).map(([sub, score]) => (
                    <div key={sub} className="bg-slate-50 px-3 py-1.5 rounded-lg border border-slate-100 flex items-center gap-2">
                        <span className="text-xs font-bold text-slate-500">{sub}</span>
                        <span className={`text-sm font-black ${(score as number) >= 90 ? 'text-indigo-600' : (score as number) >= 80 ? 'text-emerald-500' : 'text-slate-700'}`}>
                            {score}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StudentExamCard;
